module.exports = __webpack_public_path__ + "img/Home-Easy-updates.900c243e.jpg";